import { render, staticRenderFns } from "./OtpUsercomponent.vue?vue&type=template&id=879e4aba&scoped=true"
import script from "./OtpUsercomponent.vue?vue&type=script&lang=js"
export * from "./OtpUsercomponent.vue?vue&type=script&lang=js"
import style0 from "./OtpUsercomponent.vue?vue&type=style&index=0&id=879e4aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879e4aba",
  null
  
)

export default component.exports